import { secured } from '../plugins/axios';

const resource = '/menu/admin/menu';
const resourceCategories = '/menu/admin/categories';
const resourceProducts = '/menu/admin/products';
const resourceMenuTags = '/menu/admin/menu-tags';

export default {
    get: id => secured.get(`${resource}/${id}/`),
    create: payload => secured.post(`${resource}/`, payload),
    delete: id => secured.delete(`${resource}/${id}/`),

    getCategories: params => secured.get(`${resourceCategories}/`, { params }),
    getCategory: id => secured.get(`${resourceCategories}/${id}/`),
    createCategory: payload => secured.post(`${resourceCategories}/`, payload),
    updateCategory: payload => secured.put(`${resourceCategories}/${payload.id}/`, payload),
    deleteCategory: id => secured.delete(`${resourceCategories}/${id}/`),

    getMenuTags: () => secured.get(`${resourceMenuTags}/`),

    getProducts: params => secured.get(`${resourceProducts}/`, { params }),
    createProduct: payload => secured.post(`${resourceProducts}/`, payload),
    updateProduct: payload => secured.put(`${resourceProducts}/${payload.id}/`, payload),
    deleteProduct: id => secured.delete(`${resourceProducts}/${id}/`),
    uploadProductImage: (productId, payload, headers) => secured.patch(`${resourceProducts}/${productId}/`, payload, headers),

    updateImage: (id, payload, headers) => secured.put(`${resource}/${id}/`, payload, headers),
    update: payload => secured.patch(`${resource}/${payload.id}/`, payload),
};
